/**
 * @generated SignedSource<<5716a85008de887dcb0b646f2f7ef2a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimesheetsPageQueryWrapper_Query$variables = {
  personId?: string | null;
  startDateString?: string | null;
  endDateString?: string | null;
  fetchCustomFields: boolean;
};
export type TimesheetsPageQueryWrapper_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"TimesheetsPage_viewer">;
  } | null;
};
export type TimesheetsPageQueryWrapper_Query = {
  variables: TimesheetsPageQueryWrapper_Query$variables;
  response: TimesheetsPageQueryWrapper_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDateString"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchCustomFields"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDateString"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "timesheet"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"timesheet\")"
},
v6 = {
  "kind": "Variable",
  "name": "fetchCustomFields",
  "variableName": "fetchCustomFields"
},
v7 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestUser",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4User",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "MY_TIMESHEETS"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarTokenError",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarFetchEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabledCalendars",
    "storageKey": null
  },
  (v8/*: any*/)
],
v21 = [
  (v8/*: any*/),
  (v14/*: any*/)
],
v22 = {
  "kind": "Literal",
  "name": "first",
  "value": 100000
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v24 = [
  (v8/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isInternalTime",
    "storageKey": null
  },
  (v23/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disabled",
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v31 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDateString"
},
v32 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDateString"
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declineReason",
  "storageKey": null
},
v35 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v36 = [
  (v35/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v39 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomFieldDropdownOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      (v37/*: any*/)
    ],
    "storageKey": null
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": [
    (v7/*: any*/)
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v56 = [
  (v8/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activitiesEnabled",
  "storageKey": null
},
v58 = [
  (v31/*: any*/),
  (v22/*: any*/),
  (v7/*: any*/),
  (v32/*: any*/),
  {
    "kind": "Literal",
    "name": "verifyPermissionRights",
    "value": false
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOverBudgetProgramWarningApplicable",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgramType",
  "kind": "LinkedField",
  "name": "program",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectServiceProgramMemberTypeConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": (v56/*: any*/),
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v14/*: any*/),
    (v57/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v66 = [
  (v6/*: any*/),
  (v35/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TimesheetsPageQueryWrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "endDateString",
                "variableName": "endDateString"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "startDateString",
                "variableName": "startDateString"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TimesheetsPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TimesheetsPageQueryWrapper_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backendId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": "filters(filterSection:\"MY_TIMESHEETS\",first:1000000)"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegrations",
            "kind": "LinkedField",
            "name": "calendarIntegrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarIntegration",
                "kind": "LinkedField",
                "name": "googleCalendar",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarIntegration",
                "kind": "LinkedField",
                "name": "outlookCalendar",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTimeApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useInternalTimeApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTimeOffApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bambooHREnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hiBobEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4Enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "characterLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeDisabled",
                    "value": false
                  }
                ],
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(includeDisabled:false)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "internalTimes",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeDisabled",
                    "value": true
                  },
                  (v22/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "internalTime",
                    "value": true
                  }
                ],
                "concreteType": "IdleTimeTypeConnection",
                "kind": "LinkedField",
                "name": "idleTimes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "idleTimes(excludeDisabled:true,first:100000,internalTime:true)"
              },
              {
                "alias": null,
                "args": [
                  (v22/*: any*/)
                ],
                "concreteType": "IdleTimeTypeConnection",
                "kind": "LinkedField",
                "name": "idleTimes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdleTimeTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdleTime",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "idleTimes(first:100000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HolidayCalendar",
                    "kind": "LinkedField",
                    "name": "holidayCalendar",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 10000
                          }
                        ],
                        "concreteType": "HolidayCalendarEntryTypeConnection",
                        "kind": "LinkedField",
                        "name": "holidayCalendarEntries",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HolidayCalendarEntryTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HolidayCalendarEntry",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "holidayCalendarEntries(first:10000)"
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "systemUser",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "initials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "monday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tuesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wednesday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thursday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "friday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "saturday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sunday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "excludeFromCompanyLockedPeriod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submitLockedDateDay",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "economicUser",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profilePictureId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profilePictureDefaultId",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "concreteType": "PersonWeekApprovalType",
                    "kind": "LinkedField",
                    "name": "weekApprovals",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weekStartYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weekStartMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weekStartDay",
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "fetchCustomFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v36/*: any*/),
                    "concreteType": "CustomFieldDefinitionV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFieldDefinitionsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDefinitionV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v8/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entityType",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v38/*: any*/),
                                "type": "TextCustomField",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v38/*: any*/),
                                "type": "IntegerCustomField",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v38/*: any*/),
                                "type": "DecimalCustomField",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v38/*: any*/),
                                "type": "DateCustomField",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v39/*: any*/),
                                "type": "DropdownCustomField",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": "customFieldDefinitionsV2(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v36/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Company_customFieldDefinitionsV2",
                    "kind": "LinkedHandle",
                    "name": "customFieldDefinitionsV2"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "excludeReadOnly",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "excludeRestricted",
                "value": true
              },
              (v22/*: any*/)
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v14/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HarvestProjectType",
                        "kind": "LinkedField",
                        "name": "harvestProject",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Unit4ProjectType",
                        "kind": "LinkedField",
                        "name": "unit4Project",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJiraProject",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeReadOnly:true,excludeRestricted:true,first:100000)"
          },
          {
            "alias": null,
            "args": (v58/*: any*/),
            "concreteType": "TimeRegTypeConnection",
            "kind": "LinkedField",
            "name": "timeRegistrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesRegistered",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "invoiced",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "xeroInvoiceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lockedInPeriod",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "harvestTimeId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allocationId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "harvestTaskIdInt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "harvestError",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit4ActivityId",
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hiBobAllocationId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v43/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v59/*: any*/),
                          (v47/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v55/*: any*/),
                          (v62/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progress",
                            "storageKey": null
                          },
                          (v65/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jiraId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highPriority",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeLeft",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestUiUpdateAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastMinutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalMinutesRegistered",
                            "storageKey": null
                          },
                          (v48/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Task",
                            "kind": "LinkedField",
                            "name": "parentTask",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v65/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "category",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": (v56/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v43/*: any*/),
                              (v41/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              (v48/*: any*/),
                              (v40/*: any*/),
                              (v59/*: any*/),
                              (v47/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v55/*: any*/),
                              (v64/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": (v21/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdleTime",
                        "kind": "LinkedField",
                        "name": "idleTime",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isViewer",
                            "storageKey": null
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v66/*: any*/),
                        "concreteType": "CustomFieldValueV2TypeConnection",
                        "kind": "LinkedField",
                        "name": "customFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomFieldValueV2TypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v12/*: any*/),
                                  (v37/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayValue",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "TextCustomFieldValue",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "IntegerCustomFieldValue",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "DecimalCustomFieldValue",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v38/*: any*/),
                                    "type": "DateCustomFieldValue",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v39/*: any*/),
                                    "type": "DropdownCustomFieldValue",
                                    "abstractKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v66/*: any*/),
                        "filters": [
                          "fetchCustomFields"
                        ],
                        "handle": "connection",
                        "key": "TimeRegistrations_customFields",
                        "kind": "LinkedHandle",
                        "name": "customFields"
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v58/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_timeRegistrations",
            "kind": "LinkedHandle",
            "name": "timeRegistrations"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d7c8de0b873d55d47d6e0d91834c365",
    "id": null,
    "metadata": {},
    "name": "TimesheetsPageQueryWrapper_Query",
    "operationKind": "query",
    "text": "query TimesheetsPageQueryWrapper_Query(\n  $personId: ID\n  $startDateString: String\n  $endDateString: String\n  $fetchCustomFields: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"timesheet\")\n    ...TimesheetsPage_viewer_3WpPGE\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    customProjectId\n    status\n    ...DeprecatedProjectIndicatorJS_project\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n  }\n}\n\nfragment TimesheetsPage_viewer_3WpPGE on Viewer {\n  id\n  harvestUser\n  unit4User\n  actualPersonId\n  email\n  backendId\n  language\n  availableFeatureFlags {\n    key\n    id\n  }\n  filters(first: 1000000, filterSection: MY_TIMESHEETS) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  calendarIntegrations {\n    googleCalendar {\n      calendarTokenError\n      calendarFetchEnabled\n      enabledCalendars\n      id\n    }\n    outlookCalendar {\n      calendarTokenError\n      calendarFetchEnabled\n      enabledCalendars\n      id\n    }\n    id\n  }\n  company {\n    id\n    useTimeApproval\n    useInternalTimeApproval\n    useTimeOffApproval\n    harvestEnabled\n    bambooHREnabled\n    hiBobEnabled\n    sageIntacctEnabled\n    unit4Enabled\n    characterLimit\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    roles(includeDisabled: false) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    modules {\n      moduleType\n      id\n    }\n    internalTimes: idleTimes(first: 100000, internalTime: true, excludeDisabled: true) {\n      totalCount\n    }\n    idleTimes(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          isInternalTime\n          favoured\n          disabled\n        }\n      }\n    }\n    person(id: $personId) {\n      holidayCalendar {\n        id\n        holidayCalendarEntries(first: 10000) {\n          edges {\n            node {\n              id\n              day\n              month\n              year\n              name\n            }\n          }\n        }\n        name\n      }\n      id\n      role {\n        id\n        name\n      }\n      firstName\n      lastName\n      fullName\n      createdAt\n      startDate\n      endDate\n      systemUser\n      initials\n      active\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      excludeFromCompanyLockedPeriod\n      submitLockedDateYear\n      submitLockedDateMonth\n      submitLockedDateDay\n      harvestUser\n      unit4User\n      economicUser\n      profilePictureId\n      profilePictureDefaultId\n      email\n      weekApprovals(startDate: $startDateString, endDate: $endDateString) {\n        id\n        weekStartYear\n        weekStartMonth\n        weekStartDay\n        approvalStatus\n        declineReason\n      }\n    }\n    customFieldDefinitionsV2(first: 1000) @include(if: $fetchCustomFields) {\n      edges {\n        node {\n          __typename\n          id\n          key\n          type\n          displayName\n          entityType\n          ... on TextCustomField {\n            readOnly\n          }\n          ... on IntegerCustomField {\n            readOnly\n          }\n          ... on DecimalCustomField {\n            readOnly\n          }\n          ... on DateCustomField {\n            readOnly\n          }\n          ... on DropdownCustomField {\n            options {\n              id\n              displayName\n            }\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  projects(first: 100000, excludeReadOnly: true, excludeRestricted: true) {\n    edges {\n      ...ProjectDropdown_projects\n      node {\n        id\n        name\n        fullAccessToProject\n        companyProjectId\n        status\n        billable\n        projectColor\n        projectStartYear\n        projectStartMonth\n        projectStartDay\n        projectEndYear\n        projectEndMonth\n        projectEndDay\n        manualProgressOnProjectEnabled\n        manualProgressOnPhasesEnabled\n        manualProgressOnTasksEnabled\n        projectPerson(personId: $personId) {\n          role {\n            id\n            name\n          }\n          id\n        }\n        harvestProject {\n          id\n        }\n        unit4Project {\n          id\n          activitiesEnabled\n        }\n        isJiraProject\n      }\n    }\n  }\n  timeRegistrations(first: 100000, personId: $personId, startDate: $startDateString, endDate: $endDateString, verifyPermissionRights: false) {\n    edges {\n      node {\n        id\n        day\n        month\n        year\n        minutesRegistered\n        billableMinutesRegistered\n        updatedAt\n        role {\n          id\n          name\n        }\n        notes\n        invoiced\n        xeroInvoiceId\n        lockedInPeriod\n        harvestTimeId\n        allocationId\n        harvestTaskIdInt\n        harvestError\n        unit4ActivityId\n        approvalStatus\n        declineReason\n        hiBobAllocationId\n        project {\n          id\n          name\n          status\n          projectColor\n          companyProjectId\n          estimationUnit\n          fullAccessToProject\n          isOverBudgetProgramWarningApplicable\n          program {\n            name\n            prefix\n            budgetType\n            members {\n              edges {\n                node {\n                  role\n                  person {\n                    id\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n          billable\n          projectStartYear\n          projectStartMonth\n          projectStartDay\n          projectEndYear\n          projectEndMonth\n          projectEndDay\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          projectPerson(personId: $personId) {\n            role {\n              id\n              name\n            }\n            id\n          }\n          harvestProject {\n            id\n            name\n          }\n          unit4Project {\n            id\n            name\n            activitiesEnabled\n          }\n          client {\n            id\n            name\n          }\n          customProjectId\n        }\n        task {\n          id\n          name\n          progress\n          companyTaskId\n          jiraId\n          highPriority\n          approved\n          timeLeft\n          favoured\n          fullAccessToProject\n          latestUiUpdateAt\n          estimateForecastMinutes\n          totalMinutesRegistered\n          billable\n          parentTaskId\n          parentTask {\n            name\n            companyTaskId\n            id\n          }\n          startYear\n          startMonth\n          startDay\n          deadlineYear\n          deadlineMonth\n          deadlineDay\n          statusColumnV2 {\n            category\n            id\n          }\n          assignedPersons {\n            id\n          }\n          project {\n            id\n            name\n            status\n            companyProjectId\n            isOverBudgetProgramWarningApplicable\n            program {\n              name\n              prefix\n              budgetType\n              members {\n                edges {\n                  node {\n                    role\n                    person {\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n            billable\n            projectColor\n            estimationUnit\n            fullAccessToProject\n            projectStartYear\n            projectStartMonth\n            projectStartDay\n            projectEndYear\n            projectEndMonth\n            projectEndDay\n            manualProgressOnProjectEnabled\n            manualProgressOnPhasesEnabled\n            manualProgressOnTasksEnabled\n            projectPerson(personId: $personId) {\n              role {\n                id\n                name\n              }\n              id\n            }\n            client {\n              id\n              name\n            }\n            harvestProject {\n              id\n              name\n            }\n            unit4Project {\n              id\n              name\n              activitiesEnabled\n            }\n            customProjectId\n          }\n          phase {\n            id\n            name\n          }\n        }\n        idleTime {\n          id\n          name\n          isInternalTime\n          favoured\n          disabled\n        }\n        person {\n          id\n          firstName\n          lastName\n          isViewer\n          role {\n            id\n            name\n          }\n        }\n        customFields(first: 1000, fetchCustomFields: $fetchCustomFields) {\n          edges {\n            node {\n              __typename\n              key\n              displayName\n              value\n              displayValue\n              ... on TextCustomFieldValue {\n                readOnly\n              }\n              ... on IntegerCustomFieldValue {\n                readOnly\n              }\n              ... on DecimalCustomFieldValue {\n                readOnly\n              }\n              ... on DateCustomFieldValue {\n                readOnly\n              }\n              ... on DropdownCustomFieldValue {\n                options {\n                  id\n                  displayName\n                }\n              }\n              id\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d37f5202dc207e41b2690de1025d5b58";

export default node;
